import renderRadioGroup from 'components/FormControls/radioGroup'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Typography } from 'gu-ui-kit'
import formStyles from 'modules/Forms/common-form.module.scss'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useHistory } from 'react-router-dom'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import formatMoney from 'utils/formatMoney'
import { useGetAccountAction } from 'modules/Services/hooks/useGetAccountAction'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import * as Yup from 'yup'
import styles from 'modules/Forms/Account/Campaign/Start/campaign-start-form.module.scss'
import { ROUTES } from 'constants/routes'
import { useParams } from 'react-router'
import SERVICES_API_V1 from 'api/services/v1'
import { YANDEX_SUBSCRIPTION_CAMPAIGN_START } from 'modules/Services/types'

const AVAILABLE_BUDGET_TYPES = ['MINIMAL', 'OPTIMAL', 'MAXIMAL']

const validationSchema = Yup.object().shape({
  budget_type: Yup.string().oneOf(['MINIMAL', 'OPTIMAL', 'MAXIMAL']),
  duration: Yup.number().oneOf([90, 180, 360]),
})

let CampaignStartForm = ({
  handleSubmit,
  submitting,
  form,
  //promoCode = null,
}) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const selector = formValueSelector(form)
  const history = useHistory()
  const campaignsAction = useGetAccountAction('campaigns')
  const [budgets, setBudgets] = useState(null)
  const { accountId, networkType, campaignId } = useParams()

  const {
    //campaign,
    product,
    budget_type,
  } = useSelector((state) => ({
    //campaign: state['services/campaign'].campaign,
    product: selector(state, 'product'),
    budget_type: selector(state, 'budget_type'),
  }))

  const submit = useCallback(
    (values, dispatch) =>
      new Promise((resolve, reject) => {
        dispatch({
          meta: { resolve, reject },
          type: YANDEX_SUBSCRIPTION_CAMPAIGN_START,
          payload: {
            networkType: 'yandex-business',
            accountId,
            campaignId,
            data: {
              budget_type: values.budget_type,
              duration: +values.duration,
            },
            formName: form,
          },
        })
      }).then(() =>
        history.push(
          pathGen(campaignsAction.url, {
            networkType: 'yandex-business',
            accountId,
          }),
        ),
      ),
    [history, product, accountId, campaignId],
  )

  useEffect(() => {
    SERVICES_API_V1.getPrice({
      networkType: 'yandex-subscription',
      accountId,
      campaignId,
    }).then(
      ({
        response: {
          data: { budgets },
        },
      }) => setBudgets(budgets),
    )
  }, [])

  //@TODO оставляем до времен когда опять потребуется какой-нибудь промокод
  // const updatePromoCode = function (promoCode) {
  //   return function () {
  //     dispatch({
  //       type: YANDEX_SUBSCRIPTION_CAMPAIGN_SET_DATA,
  //       payload: {
  //         campaign: { ...campaign, promocode: promoCode },
  //         loading: false,
  //       },
  //     })
  //   }
  // }

  // const updatePromoCodeError = function () {
  //   dispatch({
  //     type: 'NOTIFICATION/SHOW',
  //     payload: {
  //       type: 'error',
  //       message: 'common::notifications.unexpected_error',
  //     },
  //   })
  // }

  // const updatePrices = useCallback(
  //   (promocode) => {
  //     SERVICES_API_V1.applyPromoCode({
  //       networkType: 'yandex-subscription',
  //       accountId,
  //       campaignId,
  //       data: { value: promocode },
  //     })
  //       .then(
  //         ({
  //           response: {
  //             status,
  //             data: { budgets },
  //           },
  //         }) => {
  //           if (status === 'success') {
  //             setBudgets(budgets)
  //           }
  //         },
  //       )
  //       .then(updatePromoCode({ value: promocode }))
  //       .catch(() => updatePromoCodeError())
  //   },
  //   [accountId, campaignId, setBudgets, updatePromoCode],
  // )

  // const discardPromoCode = useCallback(() => {
  //   SERVICES_API_V1.discardPromoCode({
  //     networkType: 'yandex-subscription',
  //     accountId,
  //     campaignId,
  //   })
  //     .then(
  //       ({
  //         response: {
  //           status,
  //           data: { budgets },
  //         },
  //       }) => {
  //         if (status === 'success') {
  //           setBudgets(budgets)
  //         }
  //       },
  //     )
  //     .then(updatePromoCode(null))
  //     .catch(() => updatePromoCodeError())
  // }, [accountId, campaignId, setBudgets, updatePromoCode])

  return (
    <form onSubmit={handleSubmit(submit)} noValidate>
      <div className={'margin-bottom-16'}>
        <Typography variant={'p8'} className={formStyles['legend']}>
          {t('services::campaign.launch.budget.label')}
        </Typography>

        {!budgets ? (
          <GridSpinner width={24} />
        ) : (
          <Field
            t={t}
            name="budget_type"
            component={renderRadioGroup}
            options={AVAILABLE_BUDGET_TYPES.reduce((acc, key) => {
              if (budgets[key]) {
                acc.push({
                  value: key,
                  label: (
                    <Typography
                      variant={'p9'}
                      noMargin
                      className={styles['campaign-start-form__budget-label']}
                    >
                      <span
                        className={
                          styles['campaign-start-form__budget-label-value']
                        }
                        dangerouslySetInnerHTML={{
                          __html: formatMoney(
                            budgets[key].durations[90].amount || 0,
                            'RUB',
                          ),
                        }}
                      />
                      <span
                        className={
                          styles['campaign-start-form__budget-label-predict']
                        }
                      >
                        {t('services::campaign.launch.budget.option_phrase', {
                          monthPrediction: budgets[key].monthPrediction,
                        })}
                      </span>
                    </Typography>
                  ),
                })
              }

              return acc
            }, [])}
          />
        )}
      </div>

      <div className={'margin-bottom-16'}>
        <Typography variant={'p8'} className={formStyles['legend']}>
          {t('services::campaign.launch.duration.label')}
        </Typography>

        {!budgets ? (
          <GridSpinner width={24} />
        ) : (
          <Field
            t={t}
            name="duration"
            component={renderRadioGroup}
            options={Object.keys(budgets[budget_type].durations).map((key) => {
              const durationPercentDiscount =
                budgets[budget_type].durations[key].durationPercentDiscount
              const amount = budgets[budget_type].durations[key].amount

              return {
                value: key,
                label: (
                  <Typography
                    variant={'p9'}
                    noMargin
                    className={styles['campaign-start-form__budget-label']}
                  >
                    {t('services::campaign.launch.duration.option_phrase', {
                      duration: key,
                    })}{' '}
                    (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formatMoney(amount, 'RUB'),
                      }}
                    />
                    )
                    {durationPercentDiscount !== '0' && (
                      <span
                        className={
                          styles['campaign-start-form__discount-label']
                        }
                      >
                        {t('services::campaign.launch.benefit', {
                          durationPercentDiscount: durationPercentDiscount,
                        })}
                      </span>
                    )}
                  </Typography>
                ),
              }
            })}
          />
        )}
      </div>

      {/*<PromoCodeWidget*/}
      {/*  applyPromoCode={updatePrices}*/}
      {/*  discardPromoCode={discardPromoCode}*/}
      {/*  currentPromoCode={promoCode?.value || null}*/}
      {/*/>*/}

      {/*<div className={'margin-bottom-16'}>
        <PromoCodeBanner />
      </div>*/}

      <div className={formStyles['formControl__action-buttons']}>
        <Button
          disabled={submitting}
          onClick={() =>
            history.push(
              pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT_CAMPAIGNS, {
                networkType,
                accountId,
              }),
            )
          }
          variant="default"
          size="l"
          type="button"
        >
          {t('common::form_buttons.goBack')}
        </Button>

        <Button
          disabled={submitting}
          size="l"
          variant="primary"
          type="submit"
          bgColor="Label-GU-Primary"
        >
          {t('common::form_buttons.save')}
        </Button>
      </div>
    </form>
  )
}

CampaignStartForm = reduxForm({
  form: 'CampaignStartForm',
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
  initialValues: {
    budget_type: 'MINIMAL',
    duration: '90',
  },
})(CampaignStartForm)

CampaignStartForm.propTypes = {
  accountId: PropTypes.string,
  autofill: PropTypes.func,
  invalid: PropTypes.bool,
  currentSettings: PropTypes.object,
  form: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  promoCode: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
}

export default CampaignStartForm
